const fetchPostsLikes = state => url => state.postsLikes.find(post => post.url === url);
const fetchCommentLikes = state => url => state.commentLikes.find(comm => comm.url === url);
export default {
  fetchPostsLikes,
  fetchCommentLikes,
};
